export default "__VITE_ASSET__D8716S90__"